import { MetadataType } from '@aibees/elephant/hooks';
import { capitalize } from '@aibees/shared/utils';
import { FilterCategory, SearchFilterBase, SearchFilterType } from '../types';
import { OPERATION_LANGUAGES_FILTER_OPTIONS } from './operations-languages';

export default function operationLanguageFilterConfig(): SearchFilterBase {
  return {
    name: 'Operation Language',
    icon: 'language',
    index: 14,
    layer: 3,
    type: SearchFilterType.ROOT,
    category: [FilterCategory.COMPANY_DATA],
    utils: {
      tags: {
        config: {
          showAsCard: true,
          tagsCardTitle: 'Operation Language',
        },
      },
    },
    sections: { main: 2, more: 2 },
    pinned: true,
    items: [
      {
        name: 'Include',
        type: SearchFilterType.CUSTOM_SELECT,
        index: 0,
        layer: 4,
        field: 'include_languages_for_account',
        key: 'include_languages_for_account',
        metadata: {
          color: 'primary',
          preset: 'language',
          placeholder: 'Enter Operation Language (OR) Search',
          autocomplete: {
            recent: false,
            checkboxPosition: 'left',
            multiple: true,
            customOptions: true,
          },
          metaDataApi: {
            key: MetadataType.COMPANY_LANGUAGE,
            enabled: true,
          },
        },
        utils: {
          tags: { labelFormatter: capitalize },
        },
        searchKey: 'value',
        config: { labelKey: 'value', valueKey: 'value' },
        treeOptions: OPERATION_LANGUAGES_FILTER_OPTIONS,
      },
      {
        name: 'Exclude',
        type: SearchFilterType.CUSTOM_SELECT,
        index: 1,
        layer: 4,
        key: 'exclude_languages_for_account',
        field: 'exclude_languages_for_account',
        metadata: {
          color: 'error',
          icon: 'block',
          preset: 'language',
          placeholder: 'Enter Operation Language (OR) Search',
          autocomplete: {
            recent: false,
            checkboxPosition: 'left',
            multiple: true,
            customOptions: true,
          },
          metaDataApi: {
            key: MetadataType.COMPANY_LANGUAGE,
            enabled: true,
          },
        },
        utils: {
          tags: { labelFormatter: capitalize },
        },
        searchKey: 'value',
        config: { labelKey: 'value', valueKey: 'value' },
        treeOptions: OPERATION_LANGUAGES_FILTER_OPTIONS,
      },
      {
        name: 'Include (AND)',
        type: SearchFilterType.CUSTOM_SELECT,
        index: 2,
        layer: 4,
        key: 'all_of_languages_for_account',
        field: 'all_of_languages_for_account',
        metadata: {
          color: 'warning',
          icon: 'add-task',
          preset: 'language',
          placeholder: 'Enter Operation Language (AND) Search',
          autocomplete: {
            recent: false,
            checkboxPosition: 'left',
            multiple: true,
            customOptions: true,
          },
          metaDataApi: {
            key: MetadataType.COMPANY_LANGUAGE,
            enabled: true,
          },
        },
        utils: {
          tags: { labelFormatter: capitalize },
        },
        searchKey: 'value',
        config: { labelKey: 'value', valueKey: 'value' },
        treeOptions: OPERATION_LANGUAGES_FILTER_OPTIONS,
      },
      {
        type: SearchFilterType.NUMBER_RANGE,
        icon: undefined,
        index: 3,
        layer: 4,
        field: 'number_of_languages_for_account',
        key: 'number_of_languages_for_account',
        name: '# of OP Languages',
        metadata: {
          color: 'primary',
        },
      },
    ],
  };
}
